import React from 'react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Plus, X } from "lucide-react";

export const WitnessesSection = ({ witnesses, onChange }) => {
  const update = (i, key, value) => onChange(witnesses.map((w, idx) => (idx === i ? { ...w, [key]: value } : w)));
  return (
    <div className="space-y-3">
      <Label>Witnesses</Label>
      {witnesses.map((w, i) => (
        <div key={i} className="flex gap-2" data-testid={`incident-witness-${i}`}>
          <Input placeholder="Name" value={w.name} onChange={(e) => update(i, 'name', e.target.value)} data-testid={`incident-witness-name-${i}`} />
          <Input placeholder="Phone" type="tel" value={w.phone} onChange={(e) => update(i, 'phone', e.target.value)} data-testid={`incident-witness-phone-${i}`} />
          <Button type="button" variant="ghost" size="icon" onClick={() => onChange(witnesses.filter((_, idx) => idx !== i))} data-testid={`incident-witness-remove-${i}`}>
            <X className="w-4 h-4" />
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={() => onChange([...witnesses, { name: '', phone: '' }])} data-testid="incident-add-witness-btn">
        <Plus className="w-4 h-4 mr-1" /> Add witness
      </Button>
    </div>
  );
};
